import { create } from "zustand";

interface DatenadapterState {
  localUsername: string;
  localPassword: string;
  localApiUrl: string;
  originalUsername: string;
  originalPassword: string;
  originalApiUrl: string;
  hasChanges: boolean;
  setLocalUsername: (username: string) => void;
  setLocalPassword: (password: string) => void;
  setLocalApiUrl: (url: string) => void;
  setOriginalUsername: (username: string) => void;
  setOriginalPassword: (password: string) => void;
  setOriginalApiUrl: (url: string) => void;
  resetChanges: () => void;
}

const DatenadapterStore = create<DatenadapterState>((set, get) => ({
  localUsername: "",
  localPassword: "",
  localApiUrl: "",
  originalUsername: "",
  originalPassword: "",
  originalApiUrl: "",
  hasChanges: false,

  setLocalUsername: (username: string) => {
    const { originalUsername, localPassword, originalPassword, localApiUrl, originalApiUrl } = get();
    set({
      localUsername: username,
      hasChanges: username !== originalUsername || localPassword !== originalPassword || localApiUrl !== originalApiUrl,
    });
  },

  setLocalPassword: (password: string) => {
    const { originalPassword, localUsername, originalUsername, localApiUrl, originalApiUrl } = get();
    set({
      localPassword: password,
      hasChanges: password !== originalPassword || localUsername !== originalUsername || localApiUrl !== originalApiUrl,
    });
  },

  setLocalApiUrl: (url: string) => {
    const { originalApiUrl, localUsername, originalUsername, localPassword, originalPassword } = get();
    set({
      localApiUrl: url,
      hasChanges: url !== originalApiUrl || localUsername !== originalUsername || localPassword !== originalPassword,
    });
  },

  setOriginalUsername: (username: string) => {
    const { originalPassword, localPassword, originalApiUrl, localApiUrl } = get();
    set({
      originalUsername: username,
      localUsername: username,
      hasChanges: localPassword !== originalPassword || localApiUrl !== originalApiUrl,
    });
  },

  setOriginalPassword: (password: string) => {
    const { originalUsername, localUsername, originalApiUrl, localApiUrl } = get();
    set({
      originalPassword: password,
      localPassword: password,
      hasChanges: localUsername !== originalUsername || localApiUrl !== originalApiUrl,
    });
  },

  setOriginalApiUrl: (url: string) => {
    const { originalUsername, localUsername, originalPassword, localPassword } = get();
    set({
      originalApiUrl: url,
      localApiUrl: url,
      hasChanges: localUsername !== originalUsername || localPassword !== originalPassword,
    });
  },

  resetChanges: () => {
    const { originalUsername, originalPassword, originalApiUrl } = get();
    set({
      localUsername: originalUsername,
      localPassword: originalPassword,
      localApiUrl: originalApiUrl,
      hasChanges: false,
    });
  },
}));

export default DatenadapterStore;
